import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import date from '@/helpers/date'
import api from '@/helpers/fetch'

@Component
export default class DeleteEntryModal extends Vue {
	@Prop({ required: true, type: Object }) item!: any

	localItem: any = {}
	loading = false

	// recebe data 'YYYY-MM-DD' retorna 'DD/MM/YYYY'
	formatDate(datestring) {
		if (!datestring) return ''
		const [year, month, day] = datestring.split('-')
		return `${day}/${month}/${year}`
	}

	@Watch('item', { immediate: true, deep: true })
	onItemChange(newVal: any) {
		this.localItem = { ...newVal }
	}

	async deletar() {
		this.loading = true
		const res = await api.delete(
			'/api/vacations/update/others/' + this.localItem.id,
		)
		this.loading = false

		if (res.ok) {
			this.$bvToast.toast('Lançamento deletado!', {
				title: 'Sucesso!',
				variant: 'success',
				solid: true,
				toaster: 'b-toaster-top-center',
			})
			this.$emit('change')
			this.$bvModal.hide('delete-entry-modal')
		} else {
			this.$bvToast.toast(res.msg, {
				title: 'Erro!',
				variant: 'danger',
				solid: true,
				toaster: 'b-toaster-top-center',
			})
		}
	}

	handleCancel() {
		this.$emit('cancel')
		this.$bvModal.hide('delete-entry-modal')
	}
}
